export const getBitValueFromHex = (byteIndex, bitPosition, currentHexValue, pageKey) => {
  if (!currentHexValue) return false;
  
  let expectedHexLength = 0;
  if (pageKey === 'tvr') expectedHexLength = 10;
  else if (pageKey === 'aip') expectedHexLength = 4;
  else if (pageKey === 'ctq') expectedHexLength = 4;
  else if (pageKey === 'ttq') expectedHexLength = 8;
  else if (pageKey === 'termCap') expectedHexLength = 6;
  else if (pageKey === 'appUsageControl') expectedHexLength = 4;
  else if (pageKey === 'cvmResults') expectedHexLength = 6;
  else if (pageKey === 'tag9F40') expectedHexLength = 10;
  else return false;
  
  const hexValue = currentHexValue.padStart(expectedHexLength, '0');
  const byteStartIndex = (byteIndex - 1) * 2;
  const byteHex = hexValue.substring(byteStartIndex, byteStartIndex + 2);
  if (byteHex.length !== 2) return false;
  
  const byteValue = parseInt(byteHex, 16);
  
  return (byteValue >> (bitPosition - 1)) & 1 ? true : false;
}

export const generateMissingBits = (normalRows, byteIndex, pageKey, currentHexValue) => {
  if (pageKey === 'cvmResults' && (byteIndex === 2 || byteIndex === 3)) {
    const processedRows = [];
    for (let bitPos = 8; bitPos >= 1; bitPos--) {
      let existingRow = normalRows.find(r => r.bit === bitPos);
      if (existingRow) {
        processedRows.push(existingRow);
      } else {
        processedRows.push({
          bit: bitPos,
          meaning: `Bit ${bitPos} - Undefined`,
          value: getBitValueFromHex(byteIndex, bitPos, currentHexValue, pageKey)
        });
      }
    }
    return processedRows;
  }
  
  return normalRows;
}
